import React from 'react';
import { SlidersHorizontal } from 'lucide-react';
import IconPillButton from './IconPillButton';

interface FilterIconButtonProps {
  active?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  className?: string;
  size?: 'sm' | 'md';
}

export default function FilterIconButton({
  active = false,
  disabled = false,
  onClick,
  className = '',
  size = 'md'
}: FilterIconButtonProps) {
  return (
    <IconPillButton
      icon={<SlidersHorizontal size={size === 'sm' ? 18 : 20} />}
      ariaLabel="Filter"
      active={active}
      disabled={disabled}
      onClick={onClick}
      className={className}
      size={size}
    />
  );
}
